<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
  <div>
    <Loader v-if="loading"></Loader>
    <div class="wrraper" v-else>
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        :show_print="true"
        :excelFile="true"
        :excelData="excelData"
      />
      <!-- End Breadcrumb -->
      <!-- start of searchSection  -->
      <SearchSection
        @filterTable="searchTable"
        title="تقارير حسابات المؤسسات"
      ></SearchSection>
      <!-- end of searchSection  -->
      <!-- notFound  -->
      <Notfound v-if="!searchItems"></Notfound>
      <!-- Start Statistics Card-->

      <div v-else>
        <ul class="all-state-count">
          <li>
            <div class="state-count">
              <span>عدد عمليات حسابات المؤسسات :</span>
              <span>{{ table_length }}</span>
            </div>
          </li>
        </ul>
        <!-- Start Statistics Card-->
        <h6 class="mt-7 mb-6 title-search" v-if="showReport">
          كشف حساب لحساب مؤسسة "{{ searchItems.userName }}" عن الفتره من "{{
            searchItems.from
          }}" الي "{{ searchItems.to }}"
        </h6>

        <!-- End Statistics Card-->
        <div class="table-print">
          <main class="main-table">
            <!-- start of  header of printSection  -->
            <PrintHead
              :title="'تقارير حسابات المؤسسات'"
              :number="table_length"
            ></PrintHead>
            <!-- end of header of printSection  -->
            <v-data-table
              class="thumb"
              :headers="headers"
              :items="rows"
              :loading="lodaing"
              :loading-text="$t('table.loadingData')"
              v-model="selected"
              :single-select="singleSelect"
              item-key="id"
              :items-per-page="rows.length"
              hide-default-footer
            >
              <!-- ================== You Can use any slots you want ================== -->
              <!-- ====== Select row field ====== -->
              <!-- Select no data State -->
              <template v-slot:no-data>
                {{ $t("table.noData") }}
              </template>
              <template v-slot:[`item.index`]="{ index }">
                {{ index + 1 }}
              </template>
              <template v-slot:[`item.type`]="{ item }">
                <span v-if="item.type == 'in'">إيداع رصيد محذوف </span>
                <span v-if="item.type == 'out'"> سحب مؤسسة </span>
                <span v-if="item.type == 'bill'"> إيداع إيصالات </span>
                <span v-if="item.type == 'atm'"> إيداع بنكي ATM </span>
                <span v-if="item.type == 'transfer_in'"> إيداع تحويل </span>
                <span v-if="item.type == 'transfer_out'"> سحب تحويل </span>
              </template>
              <template v-slot:[`item.commission`]="{ item }">
                {{ item.commission }}
              </template>
              <template v-slot:[`item.rate`]="{ item }">
                {{ item.rate }}
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <span
                  :class="{
                    redColor: item.amount < 0,
                    greenColor: item.amount > 0,
                  }"
                >
                  {{ Number(item.amount).toLocaleString() }}
                </span>
              </template>
              <template v-slot:[`item.total`]="{ item }">
                <span
                  :class="{
                    redColor: item.total < 0,
                    greenColor: item.total > 0,
                  }"
                >
                  {{ Number(item.total).toLocaleString() }}
                </span>
              </template>
              <template v-slot:[`item.enterprise_amount_before`]="{ item }">
                <span
                  :class="{
                    redColor: item.enterprise_amount_before < 0,
                    greenColor: item.enterprise_amount_before > 0,
                  }"
                >
                  {{ Number(item.enterprise_amount_before).toLocaleString() }}
                </span>
              </template>
              <template v-slot:[`item.enterprise_amount_after`]="{ item }">
                <span
                  :class="{
                    redColor: item.enterprise_amount_after < 0,
                    greenColor: item.enterprise_amount_after > 0,
                  }"
                >
                  {{ Number(item.enterprise_amount_after).toLocaleString() }}
                </span>
              </template>
              <template v-slot:[`item.notes`]="{ item }">
                <div class="_actions">
                  <span v-if="item.notes == 'null' || item.notes == null">
                    ----
                  </span>
                  <v-icon
                    class="show"
                    small
                    v-else
                    @click="
                      modal.notesModalIsOpen = true;
                      setItemNotes(item.notes);
                    "
                  >
                    fal fa-eye
                  </v-icon>
                </div>
              </template>

              <!-- Select actions-->
              <template v-slot:[`item.actions`]="{ item }">
                <div class="_actions">
                  <v-icon class="delete" small @click="deleteItem(item)">
                    fal fa-trash
                  </v-icon>
                </div>
              </template>

              <!-- ======================== Start Top Section ======================== -->
              <template v-slot:top>
                <!-- Delete dialog -->
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5 justify-center">{{
                      $t("table.deletedialog.areYouSure")
                    }}</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#1B5E20" @click="deleteItemConfirm"
                        >{{ $t("table.deletedialog.ok") }}
                        <span
                          class="btn_loader_model"
                          v-if="loadingBtnDialog"
                        ></span
                      ></v-btn>
                      <v-btn color="#F44336" @click="dialogDelete = false">{{
                        $t("table.deletedialog.cancel")
                      }}</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- Add & Delete -->

                <!-- Description Modal -->
                <DescModal
                  :desc="selectedItemDesc"
                  :handelModalApperance="modal.descriptionModalIsOpen"
                  @close="closeDescModal"
                />

                <NotesModal
                  :desc="selectedItemNotes"
                  :handelModalApperance="modal.notesModalIsOpen"
                  @close="closeNotesModal"
                />
              </template>
              <!-- ======================== End Top Section ======================== -->
            </v-data-table>
          </main>
          <!-- <div class="showMoney" v-if="showReport">
            <ul>
              <li>
                <div class="state-count">
                  <span> {{ user_data[1].name }} : </span>
                  <span
                    :class="{
                      redColor: user_data[1].value < 0,
                      greenColor: user_data[1].value > 0,
                    }"
                    >{{ Number(user_data[1].value).toLocaleString() }}
                    {{ user_currency }}</span
                  >
                </div>
              </li>
              <li>
                <div class="state-count">
                  <span> {{ user_data[2].name }} : </span>
                  <span
                    :class="{
                      redColor: user_data[2].value < 0,
                      greenColor: user_data[2].value > 0,
                    }"
                    >{{ Number(user_data[2].value).toLocaleString() }}
                    {{ user_currency }}</span
                  >
                </div>
              </li>
            </ul>
            <ul>
              <li style="width: 100%">
                <div class="state-count">
                  <span> {{ user_data[0].name }} : </span>
                  <span
                    :class="{
                      redColor: user_data[0].value < 0,
                      greenColor: user_data[0].value > 0,
                    }"
                    >{{ Number(this.user_data[0].value).toLocaleString() }}
                    {{ user_currency }}
                    <span class="mr-2"> "{{ allAmount }}" </span></span
                  >
                </div>
              </li>
            </ul>
          </div> -->
        </div>
      </div>
      <!-- End Pagination -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatsCard from "./../../../components/Charts/ChartComponent.vue";
import DescModal from "@/components/modals/DescriptionModal.vue";
import NotesModal from "@/components/modals/NotesModal.vue";
import SearchSection from "@/components/Search/enterprice-report";
import Tafgeet from "tafgeetjs";
export default {
  props: ["id"],

  components: {
    StatsCard,
    DescModal,
    NotesModal,
    SearchSection,
  },

  data() {
    return {
      // loadingBtnDialog
      loadingBtnDialog: false,
      // search
      searchItems: null,
      // loader
      loading: true,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: "تقارير حسابات المؤسسات",
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItems: [
        {
          id: 1,
          icon: "fal fa-images",
          title: "تقارير حسابات المؤسسات",
          number: "10",
        },
      ],

      // ========== dialog Status
      dialogShow: false,
      itemToShow: null,
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,
      // ========== Date_Menues
      from_date_menu: false,
      to_date_menu: false,

      // ========== Filter
      filter: {
        name: null,
        safe: [],
        from: null,
        to: null,
      },

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== Loding
      lodaing: false,

      // Fixed_data
      safes: ["foo", "bar", "fizz", "buzz"],
      // Custom Modal Data
      modal: {
        descriptionModalIsOpen: false,
        notesModalIsOpen: false,
      },
      selectedItemDesc: null,
      selectedItemNotes: null,
      table_length: null,
      user_data: null,
      showReport: false,
      allAmount: null,
      user_currency: null,
      // excel data
      excelData: {
        name: "تقارير حسابات المؤسسات",
        items: null,
        json_fields: {
          الحساب: "row_name",
          "نوع العملية": {
            field: "type",
            callback: (value) => {
              if (value == "in") {
                return "إيداع رصيد محذوف";
              } else if (value == "out") {
                return "سحب مؤسسة";
              } else if (value == "bill") {
                return "إيداع إيصالات";
              } else if (value == "atm") {
                return "إيداع بنكي ATM";
              } else if (value == "transfer_in") {
                return "إيداع تحويل";
              } else if (value == "transfer_out") {
                return "سحب تحويل";
              }
            },
          },
          المبلغ: {
            field: "amount",
            callback: (value) => {
              return Number(value).toLocaleString();
            },
          },
          العمولة: "commission",
          "نسبة ": "rate",
          "الرصيد قبل العملية": {
            field: "enterprise_amount_before",
            callback: (value) => {
              return Number(value).toLocaleString();
            },
          },
          "الرصيد بعد العملية": {
            field: "enterprise_amount_after",
            callback: (value) => {
              return Number(value).toLocaleString();
            },
          },
          "تاريخ العملية": "created_at",
          وصف: "desc",
        },
        footer: null,
      },
    };
  },

  watch: {
    [`paginations.current_page`]() {
      this.setRows();
    },
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            value: "index",
            sortable: false,
            align: "center",
            width: 10,
          },
          {
            text: "الحساب",
            value: "account.name",
            align: "center",
            width: 150,
          },
          {
            text: "نوع العملية",
            value: "type",
            align: "center",
            width: 120,
          },
          {
            text: "المبلغ",
            value: "amount",
            align: "center",
            sortable: false,
            width: 100,
          },
          {
            text: "العمولة",
            value: "commission",
            align: "center",
            sortable: false,
            width: 80,
          },
          {
            text: "النسبة",
            value: "rate",
            align: "center",
            sortable: false,
            width: 120,
          },
          {
            text: "الرصيد قبل العملية",
            value: "enterprise_amount_before",
            align: "center",
            sortable: false,
            width: 150,
          },
          {
            text: "الرصيد بعد العملية",
            value: "enterprise_amount_after",
            align: "center",
            sortable: false,
            width: 150,
          },
          {
            text: "تاريخ العملية",
            value: "created_at",
            align: "center",
            width: 120,
          },
          {
            text: "وصف",
            value: "desc",
            align: "center",
            sortable: false,
            width: 300,
          },
        ];
      }
    },
  },

  methods: {
    // searchTable
    searchTable(items) {
      if (items.userName) {
        this.showReport = true;
      } else {
        this.showReport = false;
      }
      this.rows = [];
      this.searchItems = items;
      this.setRows();
    },
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({
        path: this.id ? `/deposits/${this.id}/add` : `/deposits_ultimate/add`,
      });
    },
    showItem(item) {
      this.dialogShow = true;
      this.itemToShow = item;
    },
    editItem(item) {
      this.$router.push({ path: "/deposits/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "DELETE",
        url: `CrudNsame/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "topRight",
          });
          this.$store.dispatch("getTranshState");
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.lodaing = true;
      this.$axios({
        method: "GET",
        url: "client/credit_enterprise",
        params: {
          status: "confirmed",
          enterprise: this.searchItems ? this.searchItems.userId : null,
          type: this.searchItems ? this.searchItems.typeVal : null,
          from_date: this.searchItems ? this.searchItems.from : null,
          to_date: this.searchItems ? this.searchItems.to : null,
        },
      })
        .then((res) => {
          this.lodaing = false;
          this.rows = res.data.data;
          this.table_length = this.rows.length;
          this.excelData.items = this.rows;
          this.user_data = res.data.user_data;
          this.user_currency = res.data.currency;
          if (this.user_data[0].value > 0) {
            var totalNum = Number(this.user_data[0].value);
          } else {
            var totalNum = Number(this.user_data[0].value.substring(1));
          }
          var Tafgeet = require("tafgeetjs");
          if (this.user_data[0].value > 0) {
            this.allAmount = new Tafgeet(totalNum, "").parse().substring(3);
            this.allAmount =
              this.allAmount.slice(0, this.allAmount.length - 7) +
              " " +
              this.user_currency +
              " " +
              "فقط لا غير";
          } else if (this.user_data[0].value < 0) {
            this.allAmount = new Tafgeet(totalNum, "").parse().substring(3);
            this.allAmount =
              "سالب" +
              " " +
              this.allAmount.slice(0, this.allAmount.length - 7) +
              " " +
              this.user_currency +
              " " +
              "فقط لا غير";
          } else {
            this.allAmount =
              "صفر" + " " + this.user_currency + " " + "فقط لا غير";
          }
          // this.excelData.footer = [
          //   "إجمالي الإيداع : " +
          //     " " +
          //     Number(this.user_data[1].value).toLocaleString() +
          //     this.user_currency,
          //   "إجمالي السحب : " +
          //     " " +
          //     Number(this.user_data[2].value).toLocaleString() +
          //     this.user_currency,
          //   "رصيد العميل الحالي : " +
          //     " " +
          //     Number(this.user_data[0].value).toLocaleString() +
          //     this.user_currency +
          //     " " +
          //     `"${this.allAmount}"`,
          // ];
        })
        .catch((err) => {
          this.lodaing = false;
          console.log(err.response.data.message);
        });
    },
    setItemDesc(desc) {
      this.selectedItemDesc = desc;
    },
    setItemNotes(notes) {
      this.selectedItemNotes = notes;
    },
    closeDescModal() {
      this.modal.descriptionModalIsOpen = false;
    },
    closeNotesModal() {
      this.modal.notesModalIsOpen = false;
    },
  },

  // ======= hooks
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // permisions
    var userType = JSON.parse(this.$store.state.usertype) || null;
    if (!userType.includes("superadmin") && !userType.includes("enterprise")) {
      this.$router.push("/");
    }
  },
};
</script>

<style lang="scss" scoped></style>
